import React from 'react';
import Client from 'App/resources/Model/Client';
import { UnlinkSubaccount } from 'Components/Account/AccountDashboard/SubAccountStateFrame';
import StateRouter from 'App/services/StateRouter';

const goToAccount = (id: number) => () => {
	StateRouter.go('account.relations', { id }, { inherit: false });
};

export default function UnlinkSubaccountColumn({
	account,
	createNewAccountRow
}: {
	account: Client;
	createNewAccountRow: boolean;
}) {
	const Component = !createNewAccountRow ? 'div' : 'td';
	return (
		<Component className={`DataSourceColumn unlinkSubaccount ${!createNewAccountRow ? 'align-items-center' : ''}`}>
			<UnlinkSubaccount
				client={account}
				operationalAccount={account.operationalAccount}
				goToAccount={goToAccount}
			/>
		</Component>
	);
}
